import React, {ComponentProps} from 'react';
import {ThemeProvider} from '@rneui/themed';

import config from '../../../config';
import rewardsTheme from '../../../theme/rewardsTheme';

import CartScreen from './CartScreen';
import CartScreenLoyaltyEnabled from './CartScreenLoyaltyEnabled';

type Props = ComponentProps<typeof CartScreenLoyaltyEnabled>;

export default config.FF_LOYALTY_ENABLED
  ? (props: Props) => (
      <ThemeProvider theme={rewardsTheme}>
        <CartScreenLoyaltyEnabled {...props} />
      </ThemeProvider>
    )
  : CartScreen;
